import http from "@/http";

export const MonitorService = {
  async buscaChavesMonitor() {
    try {
      const { data } = await http.get("/api/monitoramento/chave-openreplay");
      return data;
    } catch (error) {
      console.error("Erro ao buscar chaves do monitor:", error);
      throw error;
    }
  }
};
